
import { Component, Vue, Prop } from 'vue-property-decorator'
import { PublicChat, SettingChangeChat, SystemChat, SingleStickerChat } from '@xt/client/entities/gensee//types.d'
import Doc from '@xt/www/pages/live/components/doc.vue'
import Chat from '@xt/www/pages/live/components/chat.vue'
import Input from '@xt/www/pages/live/components/input.vue'
import Footer from '@xt/www/pages/live/components/footer.vue'
import Video from './components/video.vue'
import { driver, type DriveStep, Config } from 'driver.js'
import { Observer } from 'mobx-vue'
import { EnumGuideStep } from '@xt/client/entities/course-v2/guide'

// 引导页
let driverObj: any = null

@Observer
@Component({
  components: {
    Video,
    Doc,
    Chat,
    Footer,
    Input
  },
  layout: 'clean',
  asyncData(ctx) {
    const courseId = ctx.query['courseId']
    return {
      courseId
    }
  }
})
export default class extends Vue {
  toggle: boolean = false
  isFullScreen: boolean = false
  onToggleScreen: boolean = false
  // 消息数据
  messageData: Array<PublicChat | SettingChangeChat | SystemChat | SingleStickerChat> = [
    {
      id: '1',
      senderId: '',
      senderUid: '111',
      sender: '丸子',
      content: '又上课了，好开心',
      type: 'PublicChat',
      privateMessageInfo: null,
      richtext: '',
      utctime: Date.now()
    },
    {
      id: '2',
      senderId: '',
      senderUid: '2222',
      sender: '小林',
      content: '每次写字笔画节奏总是把握不好，笔触太平没有变化，看起来很死板，想知道各位同学是怎么解决的',
      type: 'PublicChat',
      privateMessageInfo: null,
      richtext: '',
      utctime: Date.now()
    },
    {
      id: '3',
      senderId: '',
      senderUid: '423424',
      sender: '丸子',
      content: '多临摹，可以找一些笔触节奏比较好的字帖，多写几幅。',
      type: 'PublicChat',
      privateMessageInfo: null,
      richtext: '',
      utctime: Date.now()
    },
    {
      id: '4',
      senderId: '',
      senderUid: '3123',
      sender: 'HDD',
      content: '大家好呀',
      type: 'PublicChat',
      privateMessageInfo: null,
      richtext: '',
      utctime: Date.now()
    }
  ]
  // 课时信息数据
  classhourInfo = {
    coverUrl: 'https://static.xuantong.cn/course/class-live.png?x-oss-process=image/resize,w_128,h_128,m_lfit/quality,q_90',
    name: '第4课时',
    liveStatus: '直播未开始'
  }
  // 展示视频:
  showVideo: boolean = false
  courseId: string
  // 刷新组件
  liveVideoKey: number = 0

  liveBackgroundCoverUrl: string = 'https://file.xuantong.cn/images/origin/30bafde0178f99a343b1401f524c923b.png'

  isMoving: boolean = false
  // 防止点击过快
  onDriveNext() {
    driverObj.moveNext()
    this.isMoving = false
  }
  onDrivePrev() {
    driverObj.movePrevious()
    this.isMoving = false
  }

  get GuideData() {
    return this.$store.$courseV2.GuideData
  }

  get PageStore() {
    return this.$store.$genseeLive
  }

  // 监听视频是否播放结束
  hasLiveDemoEnd() {
    setTimeout(() => {
      driverObj.moveNext()
    }, 300)
  }
  // 初始化引导配置并开始
  onStartDrive() {
    const config: Config = {
      popoverClass: 'custom-popover-class',
      prevBtnText: '上一步',
      nextBtnText: '下一步',
      showProgress: true,
      steps: this.GuideData.dataStepTwo,
      showButtons: ['previous', 'next'],
      progressText: '{{current}} / {{total}}',
      overlayOpacity: 0,
      onPrevClick: (el, step, options) => {
        if (this.isMoving) return
        this.isMoving = true

        const steps = options.state.activeIndex! + 1
        //TODO2：等待文案处理
        // 第2步返回时隐藏蒙层
        if (steps === 2) {
          const pDom: any = document.getElementsByClassName('driver-overlay')[0].childNodes[0]
          pDom.classList.remove('show-mask')
        }

        // 视频播放时返回操作，隐藏视频
        if (steps === 8) {
          this.showVideo = false
          this.liveVideoKey += 1
        }

        // 即将结束时返回操作，展示视频
        if (steps === 9) {
          this.showVideo = true
          ;(this.$refs['videoRef'] as any).play()
        }
        this.onDrivePrev()
      },
      onNextClick: (el, step, options) => {
        if (this.isMoving) return
        this.isMoving = true

        const steps = options.state.activeIndex! + 1

        // 第1步以后显示蒙层
        if (steps === 1) {
          const pDom: any = document.getElementsByClassName('driver-overlay')[0].childNodes[0]
          pDom.classList.add('show-mask')
        }
        // 第5步-第6步之间，展示视频
        if (steps === 7) {
          this.showVideo = true
          ;(this.$refs['videoRef'] as any).play()
        }
        // 跳过操作，隐藏视频
        if (steps === 8) {
          this.showVideo = false
          this.liveVideoKey += 1
        }
        // 第一阶段结束操作
        if (steps === this.GuideData.dataStepTwo.length) {
          // 直播跳转处理
          this.$router.replace({
            name: `course-id`,
            query: {
              openThreeStage: '3'
            },
            params: {
              id: this.courseId
            },
            replace: true
          })
          return
        }

        this.onDriveNext()
      },
      onDestroyStarted: (el, step, options) => {
        // 蒙层点击操作
        this.$confirmV2({
          desc: '确认要关闭指引吗？',
          onOk: () => {
            // 直播页返回课时界面
            this.$router.replace({
              name: `course-id`,
              params: {
                id: this.courseId
              },
              replace: true
            })
            // this.$router.back()
            driverObj.destroy()
            this.GuideData.setGuideStatus(false)
          }
        })
      }
    }
    driverObj = driver(config)
    //TODO 直播阶段快捷跳转：8-最后一步
    driverObj.drive()
    this.GuideData.setStage(EnumGuideStep.Two)
  }

  created(): void {}

  mounted(): void {
    // 清除老数据
    if (this.PageStore.chatList.length > 0) {
      this.PageStore.clearChatList()
    }
    // 添加聊天数据
    this.messageData.forEach(el => {
      this.PageStore.appendChatList(el)
    })
    this.onStartDrive()
  }

  updated(): void {}

  beforeDestroy(): void {
    driverObj && driverObj.destroy()
    // 清除开课前准备的直播消息数据
    this.PageStore.clearChatList()
  }

  destroyed(): void {}
}
